/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { RequisitionLinesService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { RequisitionLineStore } from './requisition-line.store';
import {
    RequisitionLineCreate,
    RequisitionLineRead,
    RequisitionLineSearchParams,
} from '../../entities/requisition-line.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class RequisitionLineDataService extends AbstractDataService<
    RequisitionLineRead,
    RequisitionLineCreate
> {
    protected EntityName = PFWmsEntities.RequisitionLine;
    constructor(
        private service: RequisitionLinesService,
        store: RequisitionLineStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        body: RequisitionLineCreate,
        requisitionId?: string
    ): Observable<RequisitionLineRead> {
        return this.service.requisitionLineCreate({
            requisitionId: requisitionId as string,
            requisitionLineViewModelCreateBody: body,
        }) as Observable<RequisitionLineRead>;
    }
    protected deleteObs$(
        id: string,
        requisitionId?: string
    ): Observable<RequisitionLineRead> {
        return this.service.requisitionLineDelete({
            requisitionId: requisitionId as string,
            id,
        }) as Observable<RequisitionLineRead>;
    }
    protected undoDeleteObs$(
        id: string,
        requisitionId?: string
    ): Observable<RequisitionLineRead> {
        return this.service.requisitionLineUndoDelete({
            requisitionId: requisitionId as string,
            id,
        }) as Observable<RequisitionLineRead>;
    }
    protected getObs$(
        id: string,
        requisitionId?: string
    ): Observable<RequisitionLineRead> {
        return this.service.requisitionLineReadById({
            requisitionId: requisitionId as string,
            id,
        }) as Observable<RequisitionLineRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[],
        _?: RequisitionLineCreate,
        requisitionId?: string
    ): Observable<RequisitionLineRead> {
        return this.service.requisitionLineUpdatePatch({
            requisitionId: requisitionId as string,
            id,
            operation: operations,
        }) as Observable<RequisitionLineRead>;
    }
    protected searchObs$(
        searchParams: RequisitionLineSearchParams
    ): Observable<IPagedResult<RequisitionLineRead>> {
        return this.service.requisitionLineSearch(searchParams) as Observable<
            IPagedResult<RequisitionLineRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<RequisitionLineRead>>> {
        const { parentId, ...params } = searchParams;
        return this.service.requisitionLineGetChanges({
            requisitionId: parentId as string,
            ...params,
        }) as Observable<
            IPagedResult<EntityChangeTrackingDto<RequisitionLineRead>>
        >;
    }
}
